import React from "react";
import {
  Grid,
  Paper,
  Typography,
  Box,
  Button,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@mui/material/styles";
import styles from "../styles";
import ADAContactBox from "./ADAContactBox";
import TitleIXContactBox from "./TitleIXContactBox";
import ADAContactText from "./ADAContactText";
import TitleIXContactText from "./TitleIXContactText";
import DualContactText from "./DualContactText";

function ContactInfo(props) {
  const useStyles = styles;
  const theme = useTheme();
  const classes = useStyles();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));

  const ADA = "ADA";
  const TitleIX = "Title IX";
  const ADATitleIX = "ADA/Title IX";

  const getTitle = () => {
    if (props.disabilityType === ADA) return "ADA Accommodations";
    if (props.disabilityType === TitleIX) return "Title IX Accommodations";
    return "ADA/Title IX Accommodations";
  };

  const showStudentAccommodations = props.disabilityType !== TitleIX;
  const showTitleIX = props.disabilityType !== ADA;

  return (
    <Grid
      container
      role="dialog"
      aria-labelledby="contact-info-modal-title"
      className={classes.actionContainer}
      component={Paper}
      elevation={2}
      xs={12}
    >
      <Box
        className={
          matches
            ? classes.closeButtonContainer
            : classes.mobileCloseButtonContainer
        }
        onClick={() => props.setOpenModal(false)}
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === "Escape") {
            event.preventDefault();
            props.setOpenModal(false);
            return;
          }
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            props.setOpenModal(false);
          }
        }}
        role="button"
        aria-label="Close"
        style={{
          cursor: "pointer"
        }}
      >
        <Typography className={classes.closeButtonText}>Close</Typography>
      </Box>

      <Box className={classes.mainPopUpInfoContent}>
        <Box>
          <Typography
            className={classes.titleText}
            component="h2"
            id="contact-info-modal-title"
          >
            {getTitle()}
          </Typography>
        </Box>

        {props.disabilityType === ADA && <ADAContactText />}
        {props.disabilityType === TitleIX && <TitleIXContactText />}
        {props.disabilityType === ADATitleIX && <DualContactText />}

        <div style={{display: "flex", gap: "20px", marginBottom: "40px", flexWrap: "wrap"}}>
          {showStudentAccommodations && <ADAContactBox />}
          {showTitleIX && <TitleIXContactBox />}
        </div>
      </Box>

      <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <Button
          className={classes.gotItButton}
          style={{
            alignSelf: "center",
            borderRadius: "30px",
            padding: `${matches ? "8px 32px" : "2px 16px"}`,
            margin: "30px 16px 10px 0px",
            width: matches ? "253px" : "100%",
            height: matches ? "51px" : "40px",
            backgroundColor: "#DC3727",
            color: "white",
            textTransform: "none",
          }}
          aria-label="Close contact information"
          variant="contained"
          onClick={() => props.setOpenModal(false)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              props.setOpenModal(false);
            }
          }}
          tabIndex={0}
        >
          Close
        </Button>
      </div>
    </Grid>
  );
}

export default ContactInfo;